var _this = this;

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
export var EnhancedTableHead = function EnhancedTableHead(_ref) {
  var rows = _ref.rows,
      order = _ref.order,
      orderBy = _ref.orderBy,
      onRequestSort = _ref.onRequestSort,
      className = _ref.className;

  var createSortHandler = function createSortHandler(property) {
    return function (event) {
      onRequestSort(event, property);
    };
  };

  return /*#__PURE__*/React.createElement(TableHead, {
    className: className
  }, /*#__PURE__*/React.createElement(TableRow, null, rows.map(function (row, i) {
    return /*#__PURE__*/React.createElement(TableCell, {
      key: row.id,
      align: row.numeric ? 'right' : 'left',
      sortDirection: orderBy === row.id ? order : false
    }, !row.isImage ? /*#__PURE__*/React.createElement(Tooltip, {
      title: "Sort",
      placement: row.numeric ? 'bottom-end' : 'bottom-start',
      enterDelay: 300
    }, /*#__PURE__*/React.createElement(TableSortLabel, {
      active: orderBy === row.id,
      direction: order,
      onClick: createSortHandler(row.id)
    }, row.label)) : null);
  }, _this)));
};
EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string,
  rowCount: PropTypes.number.isRequired
};
export default /*#__PURE__*/memo(EnhancedTableHead);